<template>
  <div>
    <v-row class="mt-0">
      <v-col>
        <h1 class="font-weight-light pb-0 mb-4">
          <v-row justify="center" class="grey-text"> Alert Dashboard </v-row>
        </h1>
      </v-col>
    </v-row>
    <v-container
      v-if="alertDashboard"
      bg
      fill-height
      grid-list-md
      text-xs-center
    >
      <v-row>
        <v-col>
          <v-card
            ><v-card-text
              ><v-chip color="info" class="white--text">
                <v-icon class="mr-2"> mdi-information-outline </v-icon>

                Alert Rules ({{ alertDashboard.activeAlerts }})</v-chip
              >
            </v-card-text>

            <v-btn
              outlined
              small
              color="maintel-dark-green"
              class="mb-4"
              to="/table/portal_alert"
            >
              <b>Alert Rules Manager</b></v-btn
            >
          </v-card>
        </v-col>

        <v-col>
          <v-card
            ><v-card-text
              ><v-chip color="info" class="white--text">
                <v-icon class="mr-2"> mdi-email-fast-outline </v-icon>

                Alerts Sent Today ({{ alertDashboard.alertsSentToday }})</v-chip
              >
            </v-card-text>

            <v-btn
              outlined
              small
              color="maintel-dark-green"
              to="/table/alert_record"
              class="mb-4"
            >
              <b>Sent Alerts History</b></v-btn
            >
          </v-card>
        </v-col>

        <v-col>
          <v-card>
            <v-card-text
              ><v-chip color="info" class="white--text">
                <v-icon class="mr-2"> mdi-bell-ring </v-icon>

                Unread Alerts ({{ alertDashboard.unreadAlerts }})</v-chip
              ></v-card-text
            >

            <v-btn
              outlined
              small
              color="maintel-dark-green"
              to="/table/alert_record/filter-active"
              class="mb-4"
            >
              <b>Unread Alerts</b></v-btn
            >
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card ripple>
            <v-list-item>
              <v-list-item-content class="pb-0">
                <v-list-item-title class="text-h7 mb-2 text-center grey-text">
                  <router-link to="/table/portal_alert">
                    Most Recent Alerts Sent
                  </router-link>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left medium-font font-weight-light">
                      Date Sent
                    </th>
                    <th class="text-left medium-font font-weight-light">
                      Bundle Number
                    </th>
                    <th class="text-left medium-font font-weight-light">
                      MPN
                    </th>
                    <th class="text-left medium-font font-weight-light">
                      Current Usage
                    </th>
                    <th class="text-left medium-font font-weight-light">
                      Exceeded
                    </th>
                    <th class="text-left medium-font font-weight-light">
                      Type
                    </th>
                    <th>Read</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in alertDashboard.mostRecentAlerts"
                    :key="index"
                  >
                    <td width="20%" class="text-left">
                      <span v-if="item.id > 0">{{
                        $moment
                          .unix(item.dateSent / 1000)
                          .format("DD/MM/YYYY HH:mm:ss")
                      }}</span>
                    </td>
                    <td width="20%" class="text-left">
                      <span v-if="item.id > 0">{{
                        item.bundleAllocationNumber
                      }}</span>
                    </td>
                    <td width="20%" class="text-left">
                      <span v-if="item.id > 0">
                        <span v-if="item.networkSerialNumber">{{ item.networkSerialNumber }}</span>
                        <span v-if="!item.networkSerialNumber">N/A</span>
                      </span>
                    </td>
                    <td width="20%" class="text-left">
                      <span v-if="item.id > 0">
                        <span v-if="item.type == 'SPEND'">£</span
                        >{{ item.currentUsage.toFixed(2) }}
                        <span v-if="item.type == 'DATA'"> GB</span>
                        <span v-if="item.type == 'BUNDLE'">%</span>
                      </span>
                    </td>
                    <td width="20%" class="text-left">
                      <span v-if="item.id > 0">
                        <span v-if="item.type == 'SPEND'">£</span
                        >{{ item.thresholdExceeded.toFixed(2) }}
                        <span v-if="item.type == 'DATA'"> GB</span>
                        <span v-if="item.type == 'BUNDLE'">%</span>
                      </span>
                    </td>
                    <td>
                      <span v-if="item.id > 0">
                        {{ item.type }}
                      </span>
                    </td>
                    <td>{{item.isRead}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {},
  data() {
    return {
      alertDashboard: {},
      isLoading: false,
    };
  },
  methods: {
    getAlertDashboard() {
      axios
        .get("/api/mbe/alert-dash")
        .then((response) => {
          this.alertDashboard = response.data;

          console.log("this.alertDashboard", this.alertDashboard);

          this.isLoading = false;
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  mounted() {
    this.getAlertDashboard();
  },
};
</script>